import React from 'react';
import PropTypes from 'prop-types';

import styled from '@emotion/styled';
import { css } from '@emotion/core';

const checkedStyles = (props) => css`
  color: ${(props.inverted ? props.theme.color.white : props.theme.color.brand)};

  ::after {
    opacity: 1
  }

  ::before {
    border-color: ${(props.inverted ? props.theme.color.white : props.theme.color.brand)};
  }
`;

export const StyledCheckbox = styled.label`
  color: ${(props) => (props.inverted ? props.theme.color.white : props.theme.color.brand)};
  cursor: pointer;
  display: block;
  font-family: ${(props) => props.theme.font.sans};
  font-size: ${(props) => props.theme.modularScale.small};
  line-height: 18px;
  padding: 0.5rem 0 0.5rem 2em;
  position: relative;
  transition-duration: ${(props) => props.theme.animation.default};
  transition-property: color;
  transition-timing-function: ${(props) => props.theme.animation.easeOutQuad};

  ::after,
  ::before {
    position: absolute;
    transition-duration: ${(props) => props.theme.animation.default};
    transition-timing-function: ${(props) => props.theme.animation.easeOutQuad};
  }

  ::after {
    background: ${(props) => (props.inverted ? props.theme.color.white : props.theme.color.brand)};
    content: "";
    display: inline-block;
    height: 1px;
    left: -1px;
    opacity: 0;
    top: 13px;
    transform: rotate(45deg);
    transition-property: opacity;
    width: calc(1em + 2px);
  }

  ::before {
    border-color: ${(props) => (props.inverted ? props.theme.color.white : props.theme.color.brand)};
    border-radius: 1px;
    border-style: solid;
    border-width: 1px;
    content: "";
    display: inline-block;
    height: 1em;
    left: 0;
    top: 8px;
    transition-property: border-color;
    width: 1em;
  }

  ${(props) => (props.active ? checkedStyles : '')};

  input[type="checkbox"] {
    opacity: 0;
    width: 0;
    position: absolute;
  }

  &.is-hidden {
    display: none;
  }
`;

class Checkbox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.active
    };

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      this.updateCheckedStatus(this.props.active);
    }
  }

  updateCheckedStatus(checked) {
    this.setState({ checked });
  }

  handleOnChange(e) {
    this.props.changed();
    this.setState({ checked: e.target.checked });
  }

  render() {
    return (
      <StyledCheckbox
        htmlFor={this.props.id}
        name={this.props.name}
        inverted={this.props.inverted}
        active={this.state.checked}
        className={this.props.className}
      >
        {
          this.props.forwardedRef
            ? (
              <input
                ref={this.props.forwardedRef}
                id={this.props.id}
                type="checkbox"
                name={this.props.name}
                value={this.props.value}
                checked={this.state.checked}
                onChange={this.handleOnChange}
              />
            ) : (
              <input
                id={this.props.id}
                type="checkbox"
                name={this.props.name}
                value={this.props.value}
                checked={this.state.checked}
                onChange={this.handleOnChange}
              />
            )
        }
        {this.props.children}
      </StyledCheckbox>
    );
  }
}

Checkbox.defaultProps = {
  active: false,
  className: '',
  inverted: false,
  forwardedRef: () => { },
  changed: () => { }
};

Checkbox.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  className: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  id: PropTypes.string.isRequired,
  inverted: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  changed: PropTypes.func
};

export default Checkbox;
